<template>
  <div class="date-block" :style="colorsOutline" :class="{ 'date-block-international': !enFormat }" >
      <div class="date-block-date" :style="colorsDate">
        <h2 class="month">{{ month }}</h2>
        <h1 class="day">{{ day }}<sup v-show="enFormat">{{ superscript }}</sup></h1>
      </div>

      <div class="date-block-location" :style="colorsLocation">
        <h3 class="city">{{ city }}</h3>
        <h4 class="location">{{ location }}</h4>
      </div>
           
  </div>
</template>

<script>
export default {
  name: 'date-block',
  props: {
    month: String,
    day: Number,
    city: String,
    location: String,
    // style
    bg: String,
    fg: String,
  },
  computed: {
    enFormat () {
        return this.$i18n.locale === 'en';
    },
    superscript () {
        var lastDigit = this.day.toString().split('').pop();
        if (lastDigit == 1) { return "st"; } 
        else if (lastDigit == 2) { return "nd"; }
        else if (lastDigit == 3) { return "rd"; }
        else { return "th"; }
    },
    colorsLocation () {
        return {
            background: this.fg,
            color: this.bg,
            borderColor: this.bg,
        };
    },
    colorsDate () {
        return {
            background: this.bg,
            color: this.fg,
        };
    },
    colorsOutline () {
        return {
            borderColor: this.fg,
        };
    }
  }
}
</script>

<style lang="scss">
$default-color-bkg: black;
$default-color-fg: white;

.date-block {
    border: 2px solid #fff;
    margin: 15px;

    // max-width: 250px;
    width: 230px;

    h1, h2, h3, h4 {
        margin:0; padding:0;
    }
    display: flex;
    flex-direction: column;

    text-align: center;

    h1 {
        font-size: 4em;
        text-transform: uppercase;
        sup {
            font-size: .5em;
        }
    }
    h2 {
        font-size: 2em;
        text-transform: uppercase;
    }
    h3 {
        font-size: 1.5em;
        text-transform: uppercase;
        // font-variant: small-caps;
    }
    h4 {
        font-size: 1em;
        text-transform: uppercase;
    }
}
.date-block-international {
    .date-block-date {
        flex-direction: column-reverse;
    }
}
.date-block-date {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 5px 30px;

    background: $default-color-bkg;
    color: $default-color-fg;
}
.date-block-location {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 5px 30px;

    background: $default-color-fg;
    color: $default-color-bkg;
    border: 2px solid $default-color-bkg;
}
</style>
